import React from 'react';

// Renders `count` skeleton cards. `withRibbon` puts a shimmering bar on
// top of the first card so the grid echoes the "primary" ribbon that
// appears once real data loads, instead of popping in abruptly.
const BankAccountCardSkeleton = ({ count = 4 }) => {
  return (
    <div className="bank-accounts-grid">
      {Array.from({ length: count }).map((_, index) => (
        <div className="bank-account-card-skeleton" key={index}>
          {index === 0 && <div className="bank-account-card-skeleton__ribbon" />}

          <div className="bank-account-card-skeleton__body">
            <div className="bank-account-card-skeleton__identity">
              <span className="bank-account-card-skeleton__icon" />
              <div className="bank-account-card-skeleton__lines">
                <span className="bank-account-card-skeleton__line bank-account-card-skeleton__line--lg" />
                <span className="bank-account-card-skeleton__line bank-account-card-skeleton__line--sm" />
              </div>
            </div>

            <div className="bank-account-card-skeleton__details">
              <div className="bank-account-card-skeleton__row">
                <span className="bank-account-card-skeleton__label" />
                <span className="bank-account-card-skeleton__value" />
              </div>
              <div className="bank-account-card-skeleton__row">
                <span className="bank-account-card-skeleton__label" />
                <span className="bank-account-card-skeleton__value" />
              </div>
            </div>

            <span className="bank-account-card-skeleton__badge" />
          </div>

          <div className="bank-account-card-skeleton__footer">
            <span className="bank-account-card-skeleton__action" />
            <span className="bank-account-card-skeleton__action" />
            <span className="bank-account-card-skeleton__action" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default BankAccountCardSkeleton;